import { render } from "./icon-chat.svg?vue&type=template&id=28599b92"
const script = {}
script.render = render

export default script